"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _default = [[MerchandiseIds.PRODUCT_SALES_FREE, MerchandiseIds.PRODUCT_SALES_STARTER, MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019, MerchandiseIds.PRODUCT_SALES_ENTERPRISE], [MerchandiseIds.PRODUCT_MARKETING_FREE, MerchandiseIds.PRODUCT_MARKETING_STARTER, MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019, MerchandiseIds.PRODUCT_MARKETING_STARTER_MC, MerchandiseIds.PRODUCT_MARKETING_BASIC, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_MC, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_MC], [MerchandiseIds.ADDON_WEBSITE_STARTER, MerchandiseIds.ADDON_WEBSITE_UNLIMITED], [MerchandiseIds.PRODUCT_SERVICE_FREE, MerchandiseIds.PRODUCT_SERVICE_STARTER, MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE], [MerchandiseIds.PRODUCT_CMS_PROFESSIONAL, MerchandiseIds.PRODUCT_CMS_ENTERPRISE]];
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/ProductTierOrders.js
// module id = 277
// module chunks = 5 6 7